/**
 * Care Plan Library sections — keep in sync with backend
 * `care-plan/constant/sections.ts` (alphabetical by label).
 */

export const CARE_PLAN_TEMPLATE_CATEGORIES = [
  "Clinical",
  "Functional",
  "Care Planning",
];

export const CARE_PLAN_SECTIONS = [
  {
    key: "activities",
    label: "Activities",
    description: "Activities permitted / mobility allowances.",
  },
  {
    key: "advance-directives",
    label: "Advance Directives",
    description: "Advance directive and end-of-life preferences.",
  },
  {
    key: "allergies",
    label: "Allergies",
    description: "Allergy and sensitivity templates.",
  },
  {
    key: "discharge-plan",
    label: "Discharge Plan",
    description: "Discharge planning statements.",
  },
  {
    key: "dme-supplies",
    label: "DME / Supplies",
    description: "Durable medical equipment and supplies.",
  },
  {
    key: "eligibility",
    label: "Eligibility",
    description: "Homebound / eligibility documentation phrases.",
  },
  {
    key: "functional-limits",
    label: "Functional Limits",
    description: "Functional limitation statements.",
  },
  {
    key: "goals",
    label: "Goals",
    description: "Patient and discipline care goals.",
  },
  {
    key: "interventions",
    label: "Interventions",
    description: "Skilled intervention templates.",
  },
  {
    key: "mental-status",
    label: "Mental Status",
    description: "Mental / psychosocial status phrases.",
  },
  {
    key: "nutrition",
    label: "Nutrition",
    description: "Nutritional requirement templates.",
  },
  {
    key: "problems",
    label: "Problems",
    description: "Problem / diagnosis narrative templates.",
  },
  {
    key: "prognosis",
    label: "Prognosis",
    description: "Prognosis statements.",
  },
  {
    key: "rehab-potential",
    label: "Rehab Potential",
    description: "Rehabilitation potential phrases.",
  },
  {
    key: "safety",
    label: "Safety Measures",
    description: "Safety measure templates.",
  },
];

export const CARE_PLAN_META_SECTIONS = [
  {
    key: "poc-category",
    label: "POC Categories",
    description: "Plan of care category master list.",
  },
  {
    key: "related-category",
    label: "Related Categories",
    description: "Related category master list.",
  },
];

export function getCarePlanSection(key) {
  return (
    CARE_PLAN_SECTIONS.find((s) => s.key === key) ||
    CARE_PLAN_META_SECTIONS.find((s) => s.key === key) ||
    null
  );
}

export function isCarePlanMetaSection(key) {
  return CARE_PLAN_META_SECTIONS.some((s) => s.key === key);
}
